import { createReducer, createTypes } from 'reduxsauce';

export const dashboardTypes = createTypes(
  `
      SET_THINGS_DATA
      SET_REALTIME_DATA
  `,
  { prefix: 'DASHBOARD/' }
);

const INITIAL_STATE = {
  ucha: {},
  eba: {},
  realtimeData: {
    onTime: 0,
    vazao: 0,
    potencia: 0,
  },
};

// Reducers
const setThingsData = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    ...action.data,
  };
};

const setRealtimeData = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    realtimeData: {
      ...action.data,
    },
  };
};

export default createReducer(INITIAL_STATE, {
  [dashboardTypes.SET_THINGS_DATA]: setThingsData,
  [dashboardTypes.SET_REALTIME_DATA]: setRealtimeData,
});
